<template lang='pug'>
  .facilities#facilities
    button#facilities-filter
      span {{ $t('competitors_filters.more_details') }}
      span#checked-facilities {{ formattedFacilities }}
    b-popover(
      ref="filter_popover"
      triggers='click blur'
      target='facilities-filter'
      placement='bottomright'
      container='facilities'
    )
      .facilities-wrapper
        ul.facilities-list
          li(v-for='facility in facilitiesList')
            input.facilities-checkbox(
              type='checkbox'
              name='facilities'
              ref='facilityCheckbox'
              v-model='value'
              :value='facility.code'
              @change='changedFilterValue(value)'
            )
            span {{ facility.title }}
      button#check-all(@click='toggleCheckboxes') {{ checkAllTitle }}
      button.view-search-results(@click="viewSearchResults(value)") {{ $t('competitors_filters.view_search_results') }}
</template>

<script>
  import { isEmpty } from 'lodash'
  import applyFilter from '@/mixins/apply-filter'

  export default {
    mixins: [applyFilter],

    props: {
      facilities: {
        type: Array,
        default: () => ([])
      }
    },

    data() {
      return {
        checkedAll: false,
        value: this.facilities,
      }
    },

    computed: {
      checkAllTitle() {
        return this.$t('competitors_filters.check_all')
      },

      formattedFacilities() {
        if (isEmpty(this.value)) {
          return null
        } else {
          return this.value.length
        }
      },

      facilitiesList() {
        return [
          {
            code: 'pets_allowed',
            title: this.$t('facilities.pets_allowed')
          },
          {
            code: 'elevator',
            title: this.$t('facilities.elevator')
          },
          {
            code: 'delivery_box',
            title: this.$t('facilities.delivery_box')
          },
          {
            code: 'yard_waste',
            title: this.$t('facilities.yard_waste')
          },
          {
            code: 'concierge',
            title: this.$t('facilities.concierge')
          },
          {
            code: 'auto_lock',
            title: this.$t('facilities.auto_lock')
          },
          {
            code: 'parking',
            title: this.$t('facilities.parking')
          },
          {
            code: 'free_internet',
            title: this.$t('facilities.free_internet')
          },
          {
            code: 'indoor_washing_machine',
            title: this.$t('facilities.indoor_washing_machine')
          },
          {
            code: 'separated_bath_and_toilet',
            title: this.$t('facilities.separated_bath_and_toilet')
          },
          {
            code: 'independent_basin',
            title: this.$t('facilities.independent_basin')
          },
          {
            code: 'bath_dehumidifier',
            title: this.$t('facilities.bath_dehumidifier')
          },
          {
            code: 'intercom_with_monitor',
            title: this.$t('facilities.intercom_with_monitor')
          },
          {
            code: 'electronic_toilet',
            title: this.$t('facilities.electronic_toilet')
          },
          {
            code: 'city_gas',
            title: this.$t('facilities.city_gas')
          },
          {
            code: 'propane_gas',
            title: this.$t('facilities.propane_gas')
          },
          {
            code: 'bath_reheating',
            title: this.$t('facilities.bath_reheating')
          }
        ]
      }
    },

    methods: {
      toggleCheckboxes() {
        this.checkedAll = !this.checkedAll
        this.checkAll()
      },

      checkAll() {
        this.value = []

        if (this.checkedAll) {
          this.$refs.facilityCheckbox.forEach(el => {
            this.checkAllTitle = this.$t('competitors_filters.uncheck_all')
            this.value.push(el.value)
            el.checked = true
          })
        } else {
          this.$refs.facilityCheckbox.forEach(el => {
            this.checkAllTitle = this.$t('competitors_filters.check_all')
            el.checked = false
          })
        }
        this.changedFilterValue(this.value)
      }
    }
  }
</script>

<style lang='scss' scoped>
  @import '@/assets/css/mixins/competitors/filter.scss';

  .facilities {
    #facilities-filter {
      @include button-item-filter;

      #checked-facilities {
        @include span-checked-item;
      }
    }
  }

  .facilities-wrapper {
    @include item-filter-wrapper;

    .facilities-list {
      @include item-filter-ul;

      column-count: 2;

      .facilities-checkbox {
        @include item-checkbox;
      }
    }
  }

  #check-all {
    @include button-item-filter;
  }

  #facilities {
    ::v-deep.popover {
      min-width: 490px !important;
    }
  }

  .view-search-results {
    @include view-search-results;
  }
</style>
